export const DocumentSection = {
  COMPANY_FINANCIAL_DOCUMENTS : "COMPANY FINANCIAL DOCUMENTS",
  COMPANY_LOAN_DECLARATION : "COMPANY LOAN DECLARATION", 
  COMPANY_REGULATORY_AND_COMPLIANCE_DOCUMENTS : "COMPANY REGULATORY AND COMPLIANCE DOCUMENTS",
  COMPANY_OPERATIONS_AND_CASH_FLOW : "COMPANY OPERATIONS AND CASH FLOW",
  GUARANTOR_IDENTITY_AND_CREDIT_INFORMATION : "GUARANTOR IDENTITY AND CREDIT INFORMATION",
  GUARANTOR_INCOME_AND_TAX_DOCUMENTS : "GUARANTOR INCOME AND TAX DOCUMENTS"
} as const;

export type DocumentSection = typeof DocumentSection[keyof typeof DocumentSection];

export const DocumentLabels = {
  BANK_STATEMENTS: 'Bank Statements',
  FINANCIAL_STATEMENTS: 'Financial Statements',
  FORM_C_S: 'Form C/Form C-S IRAS (Optional)',
  COMPANY_LOAN_DECLARATION: 'Company Loan Declaration',
  LATEST_MONTHS_ACRA: 'Latest ACRA of the Company',
  LATEST_4_QUARTERS_GST_RETURNS: "Latest 4 Quarters’ GST Returns (F5)",
  LATEST_AR_AP_AGEING: 'Latest AR & AP Ageing (Optional)',
  NRIC_OF_GUARANTORS: 'NRIC of Guarantors',
  LATEST_MONTHS_CBS_REPORT: "Latest Month’s CBS Report of Guarantors",
  LATEST_MONTHS_MLCB_REPORT: "Latest Month’s MLCB Report of Guarantors",
  LATEST_MONTHS_BASIC_INDIVIDUAL_SEARCH: "Latest Month’s Basic Individual Search of Key Guarantors",
  LATEST_2_YEARS_NOA: "Latest 2 Years’ NOA of Guarantors",
  LATEST_YEARS_CPF_STATEMENTS: "Latest Year's CPF Statements of Guarantors (Optional)",
} as const;

export type DocumentLabel = typeof DocumentLabels[keyof typeof DocumentLabels];

export const DocumentType: Record<string, string> = {
    BANK_STATEMENTS: 'bank-statement',
    FINANCIAL_STATEMENTS: 'financial-statement',
    FORM_C_S: 'cs-iras-form',
    COMPANY_LOAN_DECLARATION: 'company-loan-declaration',
    LATEST_MONTHS_ACRA: 'acra-details',
    LATEST_4_QUARTERS_GST_RETURNS: 'gst-statement',
    LATEST_AR_AP_AGEING: 'ar-ap-ageing',
    NRIC_OF_GUARANTORS: 'nric-document',
    LATEST_MONTHS_CBS_REPORT: 'cbs-report',
    LATEST_MONTHS_MLCB_REPORT: 'mlcb-report',
    LATEST_MONTHS_BASIC_INDIVIDUAL_SEARCH: 'basic-individual-search',
    LATEST_2_YEARS_NOA: 'noa-document',
    LATEST_YEARS_CPF_STATEMENTS: 'cpf-statement',
}

export interface DocumentConfig {
  label: DocumentLabel;
  mandatory: boolean;
  uploaded: boolean;
  section: DocumentSection;
}

export const DOCUMENTS: Record<keyof typeof DocumentLabels, DocumentConfig> = {
  BANK_STATEMENTS: {
    label: DocumentLabels.BANK_STATEMENTS,
    mandatory: true,
    uploaded: false,
    section: DocumentSection.COMPANY_FINANCIAL_DOCUMENTS
  },
  FINANCIAL_STATEMENTS: {
    label: DocumentLabels.FINANCIAL_STATEMENTS,
    mandatory: true,
    uploaded: false,
    section: DocumentSection.COMPANY_FINANCIAL_DOCUMENTS
  },
  FORM_C_S: {
    label: DocumentLabels.FORM_C_S,
    mandatory: true,
    uploaded: false,
    section: DocumentSection.COMPANY_FINANCIAL_DOCUMENTS
  },
  COMPANY_LOAN_DECLARATION: {
    label: DocumentLabels.COMPANY_LOAN_DECLARATION,
    mandatory: true,
    uploaded: false,
    section: DocumentSection.COMPANY_LOAN_DECLARATION
  },
  LATEST_MONTHS_ACRA: {
    label: DocumentLabels.LATEST_MONTHS_ACRA,
    mandatory: true,
    uploaded: false,
    section: DocumentSection.COMPANY_REGULATORY_AND_COMPLIANCE_DOCUMENTS
  },
  LATEST_4_QUARTERS_GST_RETURNS: {
    label: DocumentLabels.LATEST_4_QUARTERS_GST_RETURNS,
    mandatory: true,
    uploaded: false,
    section: DocumentSection.COMPANY_REGULATORY_AND_COMPLIANCE_DOCUMENTS
  },
  LATEST_AR_AP_AGEING: {
    label: DocumentLabels.LATEST_AR_AP_AGEING,
    mandatory: false,
    uploaded: false,
    section: DocumentSection.COMPANY_OPERATIONS_AND_CASH_FLOW
  },
  NRIC_OF_GUARANTORS: {
    label: DocumentLabels.NRIC_OF_GUARANTORS,
    mandatory: true,
    uploaded: false,
    section: DocumentSection.GUARANTOR_IDENTITY_AND_CREDIT_INFORMATION
  },
  LATEST_MONTHS_CBS_REPORT: {
    label: DocumentLabels.LATEST_MONTHS_CBS_REPORT,
    mandatory: true,
    uploaded: false,
    section: DocumentSection.GUARANTOR_IDENTITY_AND_CREDIT_INFORMATION
  },
  LATEST_MONTHS_MLCB_REPORT: {
    label: DocumentLabels.LATEST_MONTHS_MLCB_REPORT,
    mandatory: true,
    uploaded: false,
    section: DocumentSection.GUARANTOR_IDENTITY_AND_CREDIT_INFORMATION
  },
  LATEST_MONTHS_BASIC_INDIVIDUAL_SEARCH: {
    label: DocumentLabels.LATEST_MONTHS_BASIC_INDIVIDUAL_SEARCH,
    mandatory: true,
    uploaded: false,
    section: DocumentSection.GUARANTOR_IDENTITY_AND_CREDIT_INFORMATION
  },
  LATEST_YEARS_CPF_STATEMENTS: {
    label: DocumentLabels.LATEST_YEARS_CPF_STATEMENTS,
    mandatory: false,
    uploaded: false,
    section: DocumentSection.GUARANTOR_INCOME_AND_TAX_DOCUMENTS
  },
  LATEST_2_YEARS_NOA: {
    label: DocumentLabels.LATEST_2_YEARS_NOA,
    mandatory: true,
    uploaded: false,
    section: DocumentSection.GUARANTOR_INCOME_AND_TAX_DOCUMENTS
  },
};